var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#453C90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5a3 3 0 100-6 3 3 0 000 6z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.5c4-4 8-7.582 8-12a8 8 0 10-16 0c0 4.418 4 8 8 12z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC41IiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgZmlsbD0iIzQ1M0M5MCIvPgo8cGF0aCBkPSJNMjQgMjUuNUMyNS42NTY5IDI1LjUgMjcgMjQuMTU2OSAyNyAyMi41QzI3IDIwLjg0MzEgMjUuNjU2OSAxOS41IDI0IDE5LjVDMjIuMzQzMSAxOS41IDIxIDIwLjg0MzEgMjEgMjIuNUMyMSAyNC4xNTY5IDIyLjM0MzEgMjUuNSAyNCAyNS41WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI0IDM0LjVDMjggMzAuNSAzMiAyNi45MTgzIDMyIDIyLjVDMzIgMTguMDgxNyAyOC40MTgzIDE0LjUgMjQgMTQuNUMxOS41ODE3IDE0LjUgMTYgMTguMDgxNyAxNiAyMi41QzE2IDI2LjkxODMgMjAgMzAuNSAyNCAzNC41WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgLocation as ReactComponent };